import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { IntegrityMonitorDefaultRuleConfigurationController } from '../controller/IntegrityMonitorDefaultRuleConfigurationController';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { Observable } from 'rxjs';

export class IntegrityMonitorDefaultRuleConfigurationWebComponent extends BaseWebComponentElement {
  public controller!: IntegrityMonitorDefaultRuleConfigurationController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorDefaultRuleConfigurationController,
    });
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }

    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  public async setRuleData(ruleData: IntegrityMonitorRuleGridItem) {
    await this.controller.setRuleData(ruleData);
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }
}
